"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const habit_1 = __importDefault(require("./habit"));
const payment_1 = __importDefault(require("./payment"));
const user_1 = __importDefault(require("./user"));
exports.default = {
    user: user_1.default,
    payment: payment_1.default,
    habit: habit_1.default,
};
